<template>
  <div class="lp lp-create">
    <f-header-lp-create/>
    <main class="main">
      <nuxt/>
    </main>
    <f-footer-lp-create/>
  </div>
</template>

<script>
import cloudfrontMixin from "~/mixins/cloudfrontMixin";

export default {
  name: 'frontend-layout',
  head() {
    return {
      meta: [
        {charset: 'utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {hid: 'description', name: 'description', content: ''}
      ],
      link: [
        {rel: 'stylesheet', type: 'text/css', href: '/frontend/css/style.css'},
      ]
    }
  },
  components: {
    FFooterLpCreate: () => import('~/components/frontend/FooterLPCreate.vue'),
    FHeaderLpCreate: () => import('~/components/frontend/Header/LPCreate.vue'),
  },
  mixins: [cloudfrontMixin],
  beforeMount() {
    if (process.client && this.$route.query.rf) {
      sessionStorage.setItem('rf', this.$route.query.rf);
    }
  },
}
</script>
